<div class="flex flex-col h-[calc(100vh-64px)] gap-4 w-full">

  <div #topSection class="flex flex-col gap-4">

  <!-- Cards de resumo -->
  <div class="flex flex-wrap gap-3">

    <!-- Total de Notificações -->
    <div class="stat-card stat-card-info flex-1 min-w-[160px]">
      <div class="stat-accent" [class.!bg-[#E41B2E]]="hasActiveFilters"></div>
      <div class="stat-icon" [class.!bg-red-50]="hasActiveFilters" [class.!text-[#E41B2E]]="hasActiveFilters">
        <i class="pi pi-list"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          Total
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.total }}</p>
        }
        <p class="text-[11px] mt-1" [class]="hasActiveFilters ? 'text-[#E41B2E]' : 'text-gray-600 dark:text-gray-400'">
          {{ hasActiveFilters ? 'resultado dos filtros' : 'todas as notificações' }}
        </p>
      </div>
    </div>

    <!-- Em Análise -->
    <div (click)="onStatCardClick('emAnalise')"
         class="stat-card flex-1 min-w-[160px]"
         [class.active]="selectedStatCard === 'emAnalise'">
      <div class="stat-accent"></div>
      <div class="stat-icon">
        <i class="pi pi-search"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          Em Análise
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.emAnalise }}</p>
          <div class="stat-progress-bar">
            <div class="stat-progress-fill"
                 [style.width]="resumo.total > 0 ? (resumo.emAnalise / resumo.total * 100) + '%' : '0%'"></div>
          </div>
        }
        <p class="text-[11px] text-gray-600 dark:text-gray-400 mt-1">
          {{ resumo.total > 0 ? ((resumo.emAnalise / resumo.total) * 100 | number:'1.0-0') + '% do total' : '—' }}
        </p>
      </div>
    </div>

    <!-- TAP Emitidos -->
    <div (click)="onStatCardClick('tap')"
         class="stat-card flex-1 min-w-[160px]"
         [class.active]="selectedStatCard === 'tap'">
      <div class="stat-accent"></div>
      <div class="stat-icon">
        <i class="pi pi-file"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          TAP Emitidos
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.tap }}</p>
        }
        <p class="text-[11px] text-gray-600 dark:text-gray-400 mt-1 truncate">
          @if (!resumoLoading) {
            {{ getResumoValor('tap') | currency:'BRL':'symbol':'1.2-2' }}
          }
        </p>
      </div>
    </div>

    <!-- Acolhidos -->
    <div (click)="onStatCardClick('acolhida')"
         class="stat-card flex-1 min-w-[160px]"
         [class.active]="selectedStatCard === 'acolhida'">
      <div class="stat-accent"></div>
      <div class="stat-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          Acolhidos
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.acolhida }}</p>
          <div class="stat-progress-bar">
            <div class="stat-progress-fill"
                 [style.width]="resumo.total > 0 ? (resumo.acolhida / resumo.total * 100) + '%' : '0%'"></div>
          </div>
        }
        <p class="text-[11px] text-gray-600 dark:text-gray-400 mt-1">
          {{ resumo.total > 0 ? ((resumo.acolhida / resumo.total) * 100 | number:'1.0-0') + '% do total' : '—' }}
        </p>
      </div>
    </div>

    <!-- Arbitral -->
    <div (click)="onStatCardClick('arbitral')"
         class="stat-card flex-1 min-w-[160px]"
         [class.active]="selectedStatCard === 'arbitral'">
      <div class="stat-accent"></div>
      <div class="stat-icon">
        <i class="pi pi-shield"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          Arbitral
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.arbitral }}</p>
          <div class="stat-progress-bar">
            <div class="stat-progress-fill"
                 [style.width]="resumo.total > 0 ? (resumo.arbitral / resumo.total * 100) + '%' : '0%'"></div>
          </div>
        }
        <p class="text-[11px] text-gray-600 dark:text-gray-400 mt-1">
          {{ resumo.total > 0 ? ((resumo.arbitral / resumo.total) * 100 | number:'1.0-0') + '% do total' : '—' }}
        </p>
      </div>
    </div>

    <!-- Anulado/Cancelado -->
    <div (click)="onStatCardClick('anuladaCancelada')"
         class="stat-card flex-1 min-w-[160px]"
         [class.active]="selectedStatCard === 'anuladaCancelada'">
      <div class="stat-accent"></div>
      <div class="stat-icon">
        <i class="pi pi-times-circle"></i>
      </div>
      <div class="flex-1 min-w-0">
        <p class="text-[10px] font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-widest mb-1 truncate">
          Anulado/Cancelado
        </p>
        @if (resumoLoading) {
          <p-skeleton height="1.75rem" width="4rem"/>
        } @else {
          <p class="text-2xl font-bold text-gray-900 dark:text-white leading-none">{{ resumo.anuladaCancelada }}</p>
          <div class="stat-progress-bar">
            <div class="stat-progress-fill"
                 [style.width]="resumo.total > 0 ? (resumo.anuladaCancelada / resumo.total * 100) + '%' : '0%'"></div>
          </div>
        }
        <p class="text-[11px] text-gray-600 dark:text-gray-400 mt-1">
          {{ resumo.total > 0 ? ((resumo.anuladaCancelada / resumo.total) * 100 | number:'1.0-0') + '% do total' : '—' }}
        </p>
      </div>
    </div>

  </div>

  <!-- Concessionárias + filtros, num unico card -->
  @if (showTopPanel) {
  @if (isInitializing || !filterForm) {
    <p-skeleton height="4rem"/>
  } @else {
    <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-red-900">
      <app-concessionaria-filter
        [concessionarias]="enumsService.concessionarias"
        [selected]="filterForm.get('concessionaria')?.value"
        (toggle)="toggleConcessionaria($event)"
        (clear)="filterForm.get('concessionaria')?.setValue(null)"
      />

      <!-- Linha discreta de filtros -->
      <div [formGroup]="filterForm"
           class="quick-filters flex flex-wrap items-end gap-3 border-t-2 border-gray-200 dark:border-red-900 px-3 py-2">
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Superintendência</span>
          <p-multi-select formControlName="superintendencia" size="small"
                          [options]="enumsService.superintendencias"
                          optionLabel="nome" optionValue="nome"
                          placeholder="Todas" appendTo="body"
                          [showClear]="true" [maxSelectedLabels]="1"
                          styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Motivo</span>
          <p-multi-select formControlName="motivo" size="small"
                          [options]="enumsService.motivos"
                          optionLabel="nome" optionValue="nome"
                          placeholder="Todos" appendTo="body"
                          [showClear]="true" [maxSelectedLabels]="1"
                          styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Fase</span>
          <p-multi-select formControlName="fase" size="small"
                          [options]="enumsService.fases"
                          optionLabel="nome" optionValue="nome"
                          placeholder="Todas" appendTo="body"
                          [showClear]="true" [maxSelectedLabels]="1"
                          styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Curso</span>
          <p-multi-select formControlName="curso" size="small"
                          [options]="enumsService.cursos"
                          optionLabel="nome" optionValue="nome"
                          placeholder="Todos" appendTo="body"
                          [showClear]="true" [maxSelectedLabels]="1"
                          styleClass="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Nº NOT</span>
          <input pInputText size="small" formControlName="numeroNotificacao" placeholder="Nº NOT" class="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Nº SEI</span>
          <input pInputText size="small" formControlName="processo" placeholder="Nº SEI" class="w-full"/>
        </div>
        <div class="flex flex-col gap-0.5 flex-1 min-w-[120px]">
          <span class="text-[9px] text-gray-400 uppercase tracking-wide">Período (Situação)</span>
          <p-date-picker appendTo="body" formControlName="dataStatus" size="small"
                         dateFormat="dd/mm/yy" placeholder="DD/MM/AAAA"
                         selectionMode="range" [readonlyInput]="true"
                         [showIcon]="true" [showClear]="true" styleClass="w-full"/>
        </div>
      </div>
    </div>
  }

  }

  </div>

  <div #card1 class="flex flex-col" [class.flex-1]="!showPagination" [class.min-h-0]="!showPagination">

    <!-- Linha de controles -->
    <div #controlsRow class="flex flex-wrap items-center gap-2 mb-3">

      <!-- Linha principal -->
      <div class="flex flex-1 flex-wrap items-center justify-between gap-2">

        <!-- Esquerda: Exibição de Colunas + Exibir Paginação -->
        <div class="flex flex-wrap items-center gap-3">
          <button type="button" (click)="toggleTopPanel()"
                  [pTooltip]="showTopPanel ? 'Ocultar filtros pra ganhar espaço na tabela' : 'Mostrar filtros'"
                  tooltipPosition="bottom"
                  class="flex items-center gap-1 text-xs text-gray-400 hover:text-red-500
                         dark:text-gray-500 dark:hover:text-red-400 transition-colors">
            <i class="pi text-[10px]" [ngClass]="showTopPanel ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
            {{ showTopPanel ? 'Ocultar filtros' : 'Mostrar filtros' }}
          </button>

          <p-button (click)="onOpenTableConfig()"
                    size="small"
                    styleClass="btn-outlined"
                    [label]="'Exibição de Colunas (' + selectedColumns.length + ')'">
            <i class="pi pi-table text-xs"></i>
          </p-button>

          <div class="flex items-center gap-2">
            <p-checkbox [(ngModel)]="showPagination" (onChange)="onChangeShowPagination()" [binary]="true"/>
            <span class="text-xs text-gray-500 dark:text-gray-400">Exibir Paginação</span>
          </div>
        </div>

        <!-- Direita: ações principais -->
        <div class="flex flex-wrap gap-2 items-center">

          <!-- Nova Notificação: oculto durante Edição Rápida -->
          @if (!bulkEditMode) {
            <p-button (click)="onClickCreate()" *hasPermission="'criar_notificacao'"
                      size="small"
                      label="Nova Notificação" styleClass="btn-red">
              <app-icon-add color="currentColor"/>
            </p-button>
          }

          <!-- Edição Rápida -->
          <p-button *hasPermission="'editar_notificacao'"
                    (click)="toggleBulkEdit()"
                    size="small"
                    [label]="bulkEditMode ? 'Desativar' : 'Edição Rápida'"
                    [styleClass]="bulkEditMode ? 'btn-red' : 'btn-outlined'">
            <i class="pi pi-pencil"></i>
          </p-button>

          <!-- Contador e limpar seleção — visível só no modo Edição Rápida -->
          @if (bulkEditMode) {
            @if (selectedRows.length > 0) {
              <span class="text-xs text-gray-500 dark:text-gray-300 self-center font-medium">
                {{ selectedRows.length }} selecionada(s)
              </span>
              <p-button size="small" label="Limpar" (click)="clearRowSelection()" styleClass="btn-outlined">
                <i class="pi pi-times"></i>
              </p-button>
            } @else if (pendingEditCount === 0) {
              <span class="text-xs text-gray-400 self-center italic">Marque linhas para editar em lote</span>
            }

            <!-- Alterações feitas na Edição Rápida ficam pendentes até confirmar em Salvar,
                 pra escolha errada + correção não virar 2 entradas no histórico. -->
            @if (pendingEditCount > 0) {
              <span class="text-xs text-amber-600 dark:text-amber-400 self-center font-medium flex items-center gap-1">
                <i class="pi pi-circle-fill text-[7px]"></i>
                {{ pendingEditCount }} alteração(ões) não salva(s)
              </span>
              <p-button size="small" label="Descartar" (click)="onClickDescartarEdicoes()" styleClass="btn-outlined">
                <i class="pi pi-undo"></i>
              </p-button>
              <p-button size="small" label="Salvar Alterações" (click)="onClickSalvarEdicoes()" styleClass="btn-red">
                <i class="pi pi-check"></i>
              </p-button>
            }
          }

          <!-- Limpar Filtros: oculto durante Edição Rápida -->
          @if (!bulkEditMode) {
            <p-button size="small" label="Limpar Filtros" (click)="onClickClearFilters()" styleClass="btn-outlined">
              <app-icon-bold-broom/>
            </p-button>

            <!-- Mais: Importar + Exportar (3 pontos) -->
            <p-button (click)="showPanelMore.toggle($event)"
                      size="small"
                      styleClass="btn-outlined">
              <i class="pi pi-ellipsis-v"></i>
            </p-button>
          }

        </div>
      </div>

    </div>

    <p-popover #showPanelMore>
      <div class="flex flex-col gap-1 w-48">
        <p class="text-xs text-gray-400 dark:text-gray-400 uppercase tracking-wide px-3 pt-1 pb-0.5">Importar</p>
        <button *hasPermission="'importar_notificacao'"
                (click)="showImportDialog = true; showPanelMore.hide()"
                class="w-full flex items-center gap-2 rounded-lg px-3 py-2
                       text-gray-600 dark:text-gray-300 font-normal hover:bg-gray-100 dark:hover:bg-red-950/20 cursor-pointer"
                pRipple type="button">
          <app-icon-import color="currentColor"/>
          <span>Planilha (.xlsx)</span>
        </button>
        <p class="text-xs text-gray-400 dark:text-gray-400 uppercase tracking-wide px-3 pt-2 pb-0.5">Exportar</p>
        <button *hasPermission="'exportar_notificacao'"
                (click)="exportarNotificacao('EXCEL'); showPanelMore.hide()"
                class="w-full flex items-center gap-2 rounded-lg px-3 py-2
                       text-gray-600 dark:text-gray-300 font-normal hover:bg-gray-100 dark:hover:bg-red-950/20 cursor-pointer"
                pRipple type="button">
          <app-icon-export color="currentColor"/>
          <span>Excel (.xlsx)</span>
        </button>
        <button *hasPermission="'exportar_notificacao'"
                (click)="exportarNotificacao('PARQUET'); showPanelMore.hide()"
                class="w-full flex items-center gap-2 rounded-lg px-3 py-2
                       text-gray-600 dark:text-gray-300 font-normal hover:bg-gray-100 dark:hover:bg-red-950/20 cursor-pointer"
                pRipple type="button">
          <app-icon-export color="currentColor"/>
          <span>Parquet (.parquet)</span>
        </button>
        <ng-container *hasPermission="'editar_notificacao'">
          <div class="border-t border-gray-100 dark:border-red-950 my-1"></div>
          <p class="text-xs text-gray-400 dark:text-gray-400 uppercase tracking-wide px-3 pt-1 pb-0.5">Personalizar</p>
          <button (click)="openExtraColumnsDialog(); showPanelMore.hide()"
                  class="w-full flex items-center gap-2 rounded-lg px-3 py-2
                         text-gray-600 dark:text-gray-300 font-normal hover:bg-gray-100 dark:hover:bg-red-950/20 cursor-pointer"
                  pRipple type="button">
            <i class="pi pi-plus-circle"></i>
            <span>Campos Extras</span>
            @if (extraColumns.length > 0) {
              <span class="ml-auto text-[10px] bg-[#E41B2E]/10 text-[#E41B2E] rounded-full px-1.5 py-0.5 font-semibold">
                {{ extraColumns.length }}
              </span>
            }
          </button>
        </ng-container>
      </div>
    </p-popover>

    @if (isInitializing) {
      <p-skeleton width="100%" height="100px"></p-skeleton>
    } @else {
      <div #tableContainer appStickyHorizontalScroll translate="no" class="notranslate flex flex-col overflow-x-hidden"
           [class.flex-1]="!showPagination" [class.min-h-0]="!showPagination"
           [class.overflow-hidden]="!showPagination">

        <p-table
          #table
          [value]="notificacoes"
          dataKey="id"

          (onLazyLoad)="onLazyLoad($event)"
          [lazyLoadOnInit]="showPagination"
          [lazy]="true"

          [columns]="selectedColumns"
          [first]="pagination.first"
          [rows]="getNumberOfRows()"

          [scrollable]="true"
          [virtualScroll]="!showPagination"
          [scrollHeight]="showPagination ? undefined : tableScrollHeight"
          [virtualScrollItemSize]="virtualScrollItemSize"
          [virtualScrollOptions]="{ trackBy: trackByIndex, appendOnly: true, autoSize: false, itemSize: virtualScrollItemSize }"
          [virtualScrollDelay]="0"

          [paginator]="showPagination"
          [rowsPerPageOptions]="options"
          [totalRecords]="pagination.totalItems"
          [paginatorStyleClass]="'table-paginator'"
          [paginatorDropdownAppendTo]="'body'"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="`${displayFirst} - ${displayLast} de ${pagination.totalItems} registros`"

          [sortMode]="'single'"
          [resetPageOnSort]="true"
          (onSort)="onSort($event)"

          [loading]="loading"
          [showLoader]="false"

          [rowHover]="true"

          class="flex-1 min-h-0 flat-table"
          [tableStyle]="{'min-width': '50rem'}"
        >
          <ng-template #header let-columns>
            <tr>
              @if (selectedColumns.length > 0) {
                <th pFrozenColumn alignFrozen="left" class="text-center bg-white dark:bg-black" style="width:120px">
                  @if (bulkEditMode) {
                    <div class="flex items-center justify-center gap-1">
                      <input type="checkbox"
                             class="w-4 h-4 accent-red-600 cursor-pointer"
                             [checked]="allRowsSelected()"
                             [indeterminate]="someRowsSelected()"
                             (change)="toggleAllRows()"
                             title="Selecionar / desselecionar tudo"/>
                      <span class="text-xs text-gray-400 font-normal">Tudo</span>
                    </div>
                  } @else {
                    <div class="flex items-center justify-center gap-1.5">
                      <span>Ações</span>
                      <button type="button" (click)="toggleColumnFilters()"
                              [title]="showColumnFilters ? 'Ocultar filtros das colunas' : 'Mostrar filtros das colunas'"
                              class="relative flex items-center justify-center w-4 h-4 rounded hover:bg-white/20 transition-colors">
                        <i class="pi text-[10px]" [ngClass]="showColumnFilters ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                        @if (!showColumnFilters && hasActiveFilters) {
                          <span class="absolute -top-0.5 -right-0.5 w-1.5 h-1.5 rounded-full bg-yellow-300"></span>
                        }
                      </button>
                    </div>
                  }
                </th>
              }
              @for (column of columns; track $index) {
                <th [pSortableColumn]="column.field"
                    [frozen]="column.fixed === true"
                    alignFrozen="left"
                    pFrozenColumn
                    class="text-center p-2 min-w-[200px] truncate whitespace-nowrap overflow-hidden bg-white dark:bg-black">
                  <div class="flex items-center text-center w-full justify-center gap-1.5">
                    {{ column.label }}
                    @if (column.sortable) {
                      <p-sortIcon [field]="column.field" pTooltip="Ordenar" tooltipPosition="bottom"/>
                    }
                  </div>
                </th>
              }
              @for (col of extraColumns; track col.id) {
                <th class="text-center p-2 min-w-[160px] truncate whitespace-nowrap overflow-hidden">
                  <div class="flex items-center justify-center gap-1">
                    <span>{{ col.label }}</span>
                    <span class="text-[9px] px-1 py-0.5 rounded bg-purple-100 dark:bg-purple-950/30 text-purple-600 dark:text-purple-400 font-semibold uppercase">extra</span>
                  </div>
                </th>
              }
            </tr>
            <tr [formGroup]="filterForm" [class.hidden]="!showColumnFilters">
              @if (selectedColumns.length > 0) {
                <th pFrozenColumn alignFrozen="left" class="bg-white dark:bg-black" style="width:120px"></th>
              }
              @for (column of selectedColumns; track $index) {
                <th
                  [frozen]="column.fixed === true"
                  alignFrozen="left"
                  pFrozenColumn
                  [ngClass]="{'min-w-[260px]' : column.format == 'daterange', 'min-w-[96px]' : column.format != 'daterange'}"
                  class="p-1 bg-white dark:bg-black overflow-hidden">
                  @switch (column.format) {
                    @case ('select') {
                      <p-multi-select formControlName="{{column.field}}" size="small"
                                      placeholder="Selecione" [options]="column.filterOptions ?? column.options ?? []"
                                      appendTo="body" [maxSelectedLabels]="2" [showClear]="true"
                                      optionLabel="nome" optionValue="nome" fluid>
                      </p-multi-select>
                    }
                    @case ('status') {
                      <p-multi-select formControlName="{{column.field}}" size="small"
                                      placeholder="Selecione" [options]="column.filterOptions ?? column.options ?? []"
                                      appendTo="body" [maxSelectedLabels]="2" [showClear]="true"
                                      optionLabel="nome" optionValue="nome" fluid>
                      </p-multi-select>
                    }
                    @case ('daterange') {
                      <p-date-picker appendTo="body" formControlName="{{column.field}}" size="small"
                                     dateFormat="dd/mm/yy" placeholder="DD/MM/AAAA"
                                     selectionMode="range" [readonlyInput]="true"
                                     [showIcon]="true" [showClear]="true" fluid>
                      </p-date-picker>
                    }
                    @case ('date') {
                      <p-date-picker appendTo="body" formControlName="{{column.field}}" size="small"
                                     dateFormat="dd/mm/yy" placeholder="DD/MM/AAAA"
                                     [readonlyInput]="true" [showIcon]="true" [showClear]="true" fluid>
                      </p-date-picker>
                    }
                    @default {
                      <p-iconfield>
                        <input pInputText formControlName="{{column.field}}" size="small" placeholder="Pesquise" fluid/>
                        <p-inputicon class="pi pi-search"/>
                      </p-iconfield>
                    }
                  }
                </th>
              }
              @for (col of extraColumns; track col.id) {
                <th class="p-1 min-w-[160px]"></th>
              }
            </tr>
          </ng-template>
          @if (!loading) {
            <ng-template #body let-columns="columns" let-item>
              <tr [ngClass]="bulkEditMode && isRowSelected(item) ? 'bg-red-50 dark:bg-red-950/20 ring-1 ring-inset ring-red-200' : ''"
                  style="height:40px">
                @if (selectedColumns.length > 0) {
                  <td pFrozenColumn alignFrozen="left"
                      [ngClass]="bulkEditMode && isRowSelected(item) ? 'bg-red-50 dark:bg-red-950/20' : 'bg-white dark:bg-black'"
                      style="width:120px" (click)="$event.stopPropagation()">
                    @if (bulkEditMode) {
                      <div class="flex justify-center items-center h-full">
                        <input type="checkbox"
                               class="w-4 h-4 accent-red-600 cursor-pointer"
                               [checked]="isRowSelected(item)"
                               (change)="onRowClick(item)"
                               [attr.aria-label]="'Selecionar notificação ' + item.id"/>
                      </div>
                    } @else {
                      <div class="flex justify-center items-center gap-1">
                        <p-button *hasPermission="'editar_notificacao'"
                                  pButtonIcon pTooltip="Editar" (click)="onClickEdit(item.id)"
                                  styleClass="btn-icon-highlight" tooltipPosition="bottom">
                          <app-icon-bold-edit color="#FFFFFF"></app-icon-bold-edit>
                        </p-button>
                        <p-button pButtonIcon pTooltip="Visualizar" (click)="onClickView(item.id)"
                                  styleClass="btn-icon" tooltipPosition="bottom">
                          <app-icon-bold-eye color="#494949"></app-icon-bold-eye>
                        </p-button>
                        <p-button *hasPermission="'excluir_notificacao'"
                                  pButtonIcon pTooltip="Excluir" (click)="onClickDelete(item.id)"
                                  styleClass="btn-icon" tooltipPosition="bottom">
                          <app-icon-bold-trash color="#E41B2E"></app-icon-bold-trash>
                        </p-button>
                      </div>
                    }
                  </td>
                }
                @for (column of columns; track $index) {
                  <td
                    [frozen]="column.fixed === true"
                    alignFrozen="left"
                    pFrozenColumn
                    [appSmartTooltip]="(bulkEditMode && column.quickEdit) || (column.field === 'processo' && seiAtivo()) ? '' : formatTooltip(item, column)"
                    tooltipPosition="auto"
                    tooltipStyleClass="custom-tooltip"
                    appendTo="body"
                    [ngClass]="[
                      bulkEditMode && column.quickEdit ? 'p-1' : '',
                      column.fixed ? (bulkEditMode && isRowSelected(item) ? 'bg-red-50 dark:bg-red-950/20' : 'bg-white dark:bg-black') : '',
                      column.field === 'localizacao' ? 'min-w-[340px] max-w-[420px]' : 'max-w-[200px]'
                    ]"
                    class="text-left truncate whitespace-nowrap overflow-hidden">
                    @if (bulkEditMode && column.quickEdit && isEditingCell(item.id, column.field)) {
                      <div (click)="$event.stopPropagation()">
                        @if (column.format === 'date' || column.format === 'daterange') {
                          <p-date-picker
                            [ngModel]="parseDateForPicker(item[column.field])"
                            (ngModelChange)="onInlineDateChange(item, column.field, $event)"
                            dateFormat="dd/mm/yy"
                            appendTo="body"
                            [showIcon]="true"
                            [showClear]="true"
                            (onClose)="stopCellEdit()"
                            styleClass="w-full text-xs"/>
                        } @else {
                          <p-select
                            [options]="column.options"
                            optionLabel="nome"
                            [ngModel]="getEnumOption(column.options, item[column.field])"
                            (onChange)="onInlineFieldChange(item, column.field, $event.value)"
                            (onHide)="stopCellEdit()"
                            appendTo="body"
                            placeholder="Selecione"
                            [showClear]="false"
                            [autofocus]="true"
                            styleClass="w-full text-xs"/>
                        }
                      </div>
                    } @else {
                      @if (bulkEditMode && column.quickEdit) {
                        <!-- Célula editável: visual de select/dropdown clicável igual ao SIGEP.
                             Fica com borda/fundo amber enquanto a alteração não foi salva. -->
                        <button type="button"
                                (click)="startCellEdit(item, column.field, $event)"
                                [ngClass]="{'!border-amber-400 !bg-amber-50 dark:!bg-amber-950/30': hasPendingEdit(item.id, column.field)}"
                                class="relative flex items-center justify-between w-full min-w-0 px-1.5 py-0.5
                                       border border-gray-300 dark:border-zinc-600 rounded
                                       bg-white dark:bg-zinc-800
                                       hover:border-red-400 hover:bg-red-50 dark:hover:bg-red-950/30
                                       text-left text-xs text-gray-700 dark:text-gray-200
                                       transition-colors group/qe cursor-pointer">
                          @if (hasPendingEdit(item.id, column.field)) {
                            <i class="pi pi-circle-fill text-amber-500 absolute -top-1 -left-1 text-[8px]"
                               pTooltip="Alteração ainda não salva" tooltipPosition="top"></i>
                          }
                          <span class="flex-1 min-w-0 truncate">
                            @switch (column.format) {
                              @case ('date') {
                                {{ item[column.field] ? (item[column.field] | date: 'dd/MM/yyyy') : 'dd/mm/aaaa' }}
                              }
                              @case ('daterange') {
                                {{ item[column.field] ? (item[column.field] | date: 'dd/MM/yyyy') : 'dd/mm/aaaa' }}
                              }
                              @case ('status') {
                                <app-status-label [status]="item[column.field]"/>
                              }
                              @default {
                                <span [class.text-gray-400]="!item[column.field]">
                                  {{ item[column.field] || 'Selecionar...' }}
                                </span>
                              }
                            }
                          </span>
                          <i class="pi pi-chevron-down text-[9px] flex-shrink-0 ml-1
                                     text-gray-400 group-hover/qe:text-red-500 transition-colors"></i>
                        </button>
                      } @else {
                        @switch (column.format) {
                          @case ('date') { {{ item[column.field] | date: 'dd/MM/yyyy' }} }
                          @case ('daterange') { {{ item[column.field] | date: 'dd/MM/yyyy' }} }
                          @case ('currency') { {{ item[column.field] | currency:'BRL':'symbol':'1.2-2':'pt-BR' }} }
                          @case ('percent') { {{ (item[column.field] / 100) | percent:'1.2-2' }} }
                          @case ('status') { <app-status-label [status]="item[column.field]"/> }
                          @default {
                            @if (column.field === 'processo') { <app-abrir-sei [texto]="item.processo"/> }
                            @else if (column.field === 'localizacao' && item.localizacao?.includes(',')) {
                              <!-- várias unidades (ex.: gravadas pelo Bot SisNot ↔ SEI): uma em cada linha -->
                              @for (unidade of linhasLocalizacao(item.localizacao); track $index) {
                                <div class="truncate">{{ unidade }}</div>
                              }
                            }
                            @else { {{ item[column.field] || '—' }} }
                          }
                        }
                      }
                    }
                  </td>
                }
                @for (col of extraColumns; track col.id) {
                  <td class="p-1 min-w-[160px]">
                    <input [type]="col.type === 'date' ? 'date' : col.type === 'number' ? 'number' : 'text'"
                           [value]="getExtraValue(item.id, col.id)"
                           (change)="setExtraValue(item.id, col.id, $any($event.target).value)"
                           class="w-full text-sm border border-transparent rounded px-2 py-1 bg-transparent
                                  hover:border-gray-200 dark:hover:border-red-900
                                  focus:outline-none focus:border-gray-300 dark:focus:border-red-700
                                  transition-colors"/>
                  </td>
                }
              </tr>
            </ng-template>
          }
          <ng-template #emptymessage>
            @if (!loading) {
              <tr>
                <td [attr.colspan]="7">Nenhum registro encontrado.</td>
              </tr>
            }
          </ng-template>
          <ng-template #loadingbody>
            @if (selectedColumns.length > 0) {
              @for (i of [1, 2, 3]; track $index) {
                <tr>
                  @for (column of selectedColumns; track column.field) {
                    <td>
                      <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                    </td>
                  }
                  <td>
                    <p-skeleton height="1.5rem" width="100%"></p-skeleton>
                  </td>
                </tr>
              }
            }
          </ng-template>
        </p-table>
        <!--        <app-custom-table-paginator-->
        <!--          (onRowsChange)="handleChangeNumberOfRows($event)"-->
        <!--          (pageChange)="handleChangePaginator($event)"-->
        <!--          [first]="pagination.first"-->
        <!--          [rows]="pagination.rows"-->
        <!--          [totalItems]="pagination.totalItems">-->
        <!--        </app-custom-table-paginator>-->
      </div>
    }
  </div>

</div>

<!-- Dialog: Configurar Tabela -->
<p-dialog [(visible)]="showTableConfigDialog"
          [closable]="true"
          [modal]="true"
          [style]="{width: '480px', maxHeight: '90vh'}"
          id="tableConfigDialog">
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="pi pi-table text-[#E41B2E]"></i>
      <span class="header-title-dialog">Exibição de Colunas</span>
    </div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between">
      <span class="text-sm text-gray-500 dark:text-gray-400">
        {{ configColumns.length }} colunas · {{ visibleColumnsCount }} visíveis
      </span>
      <div class="flex gap-2">
        <button (click)="showAllColumns()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Todas
        </button>
        <button (click)="hideAllColumns()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Nenhuma
        </button>
        <button (click)="resetTableConfig()"
                class="text-xs px-2 py-1 rounded bg-gray-100 dark:bg-black/40 text-gray-600 dark:text-red-600
                       hover:bg-gray-200 dark:hover:bg-red-950/30 transition-colors">
          Padrão
        </button>
      </div>
    </div>

    <p class="text-xs text-gray-400 dark:text-gray-400 flex items-center gap-1">
      <i class="pi pi-info-circle"></i>
      Arraste para reordenar. Marque para exibir.
    </p>

    <div cdkDropList (cdkDropListDropped)="onColumnDrop($event)"
         class="flex flex-col gap-1 max-h-[420px] overflow-y-auto pr-1">
      @for (item of configColumns; track item.col.field) {
        <div cdkDrag
             class="flex items-center gap-3 px-3 py-2 rounded-lg border transition-colors
                    bg-white dark:bg-black border-gray-200 dark:border-red-950
                    hover:border-gray-300 dark:hover:border-red-800"
             [class.opacity-50]="!item.visible">
          <i class="pi pi-bars text-gray-300 dark:text-gray-400 cursor-grab" cdkDragHandle></i>
          <p-checkbox [(ngModel)]="item.visible" [binary]="true"/>
          <span class="text-sm flex-1 truncate"
                [ngClass]="item.visible ? 'text-gray-900 dark:text-white' : 'text-gray-400 dark:text-gray-400'">
            {{ item.col.label }}
          </span>
          <button (click)="item.fixed = item.visible && !item.fixed; $event.stopPropagation()"
                  [title]="item.fixed ? 'Desafixar coluna' : 'Fixar coluna à esquerda'"
                  [disabled]="!item.visible"
                  class="stat-filter-btn"
                  [class.open]="item.fixed">
            <i class="pi pi-thumbtack text-sm"></i>
          </button>
          <div *cdkDragPlaceholder
               class="h-10 rounded-lg border-2 border-dashed border-[#E41B2E]/40 bg-[#E41B2E]/04"></div>
        </div>
      }
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Cancelar"
                styleClass="btn-transparent"
                (click)="showTableConfigDialog = false"/>
      <p-button label="Aplicar"
                styleClass="btn-red"
                (click)="applyTableConfig()">
        <i class="pi pi-check"></i>
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog: Campos Extras -->
<p-dialog [(visible)]="showExtraColumnsDialog"
          [closable]="true"
          [modal]="true"
          [style]="{width: '500px', maxHeight: '90vh'}">
  <ng-template #header>
    <div class="flex items-center gap-2">
      <i class="pi pi-plus-circle text-[#E41B2E]"></i>
      <span class="header-title-dialog">Campos Extras</span>
    </div>
  </ng-template>

  <div class="flex flex-col gap-4">
    <p class="text-sm text-gray-500 dark:text-gray-400 -mt-1">
      Colunas extras são salvas localmente e visíveis apenas neste navegador.
    </p>

    <!-- Lista de campos existentes -->
    <div class="flex flex-col gap-1 max-h-[260px] overflow-y-auto pr-1">
      @if (extraColumns.length === 0) {
        <p class="text-sm text-gray-400 dark:text-gray-400 text-center py-6">Nenhum campo extra adicionado ainda.</p>
      } @else {
        @for (col of extraColumns; track col.id) {
          <div class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 dark:border-red-950 bg-white dark:bg-black">
            <i class="pi pi-bars text-gray-300 dark:text-gray-400"></i>
            <span class="flex-1 text-sm font-medium text-gray-800 dark:text-gray-200">{{ col.label }}</span>
            <span class="text-xs px-2 py-0.5 rounded-full"
                  [ngClass]="{
                    'bg-blue-50 text-blue-600 dark:bg-blue-950/30 dark:text-blue-400': col.type === 'text',
                    'bg-green-50 text-green-600 dark:bg-green-950/30 dark:text-green-400': col.type === 'number',
                    'bg-yellow-50 text-yellow-600 dark:bg-yellow-950/30 dark:text-yellow-400': col.type === 'date'
                  }">
              {{ col.type === 'text' ? 'Texto' : col.type === 'number' ? 'Número' : 'Data' }}
            </span>
            <button (click)="removeExtraColumn(col.id)" type="button" title="Remover campo"
                    class="text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-950/20 p-1 rounded transition-colors">
              <i class="pi pi-times text-sm"></i>
            </button>
          </div>
        }
      }
    </div>

    <!-- Formulário para adicionar -->
    <div class="border-t border-gray-100 dark:border-red-950 pt-4">
      <p class="text-xs text-gray-400 dark:text-gray-400 uppercase tracking-wide mb-3">Adicionar Campo</p>
      <div class="flex gap-2">
        <input pInputText [(ngModel)]="newExtraColLabel" placeholder="Nome do campo"
               class="flex-1" (keydown.enter)="addExtraColumn()"/>
        <p-select [(ngModel)]="newExtraColType"
                  [options]="[{label: 'Texto', value: 'text'}, {label: 'Número', value: 'number'}, {label: 'Data', value: 'date'}]"
                  optionLabel="label" optionValue="value"
                  appendTo="body"
                  [style]="{width: '120px'}"/>
        <p-button styleClass="btn-red" (click)="addExtraColumn()" [disabled]="!newExtraColLabel.trim()" pTooltip="Adicionar campo" tooltipPosition="bottom">
          <i class="pi pi-plus"></i>
        </p-button>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-2">
      <p-button label="Fechar" styleClass="btn-transparent" (click)="showExtraColumnsDialog = false"/>
    </div>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="showViewDialog"
          [closable]="true"
          [modal]="true"
          id="viewDialog"
>
  <ng-template #header>
    <div class="flex items-center w-full pr-4">
      <div class="header-title-dialog">Visualizar Notificação</div>
    </div>
  </ng-template>

  <ng-content>
    <p-fluid>
      @if (viewForm) {
        <form [formGroup]="viewForm"
              class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          <div class="flex flex-col gap-2">
            <label for="superintendencia">Superintendência</label>
            <input id="superintendencia" pInputText formControlName="superintendencia"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="diretoria">Diretoria</label>
            <input id="diretoria" pInputText formControlName="diretoria"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="gerencia">Gerência</label>
            <input id="gerencia" pInputText formControlName="gerencia"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="cff">Item CFF</label>
            <input id="cff" pInputText formControlName="cff"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="numeroNotificacao">N NOT</label>
            <input id="numeroNotificacao" pInputText formControlName="numeroNotificacao"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="dataNotificacao">Data NOT</label>
            <p-date-picker id="dataNotificacao" dateFormat="dd/mm/yy" formControlName="dataNotificacao"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="concessionaria">Concessionária</label>
            <input id="concessionaria" pInputText formControlName="concessionaria"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="categoria">Categoria</label>
            <input id="categoria" pInputText formControlName="categoria"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="processo">Processo <app-abrir-sei modo="link" [texto]="viewForm.get('processo')?.value"/></label>
            <input id="processo" pInputText formControlName="processo"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="descricao">Descrição</label>
            <input id="descricao" pInputText formControlName="descricao"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="motivo">Motivo</label>
            <input id="motivo" pInputText formControlName="motivo"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="status">Status</label>
            <input id="status" pInputText formControlName="status"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="dataStatus">Data Status</label>
            <p-date-picker id="dataStatus" dateFormat="dd/mm/yy" formControlName="dataStatus"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="fase">Fase</label>
            <input id="fase" pInputText formControlName="fase"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="dataFase">Data Fase</label>
            <p-date-picker id="dataFase" dateFormat="dd/mm/yy" formControlName="dataFase"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="valorP0">Valor P0</label>
            <p-inputNumber id="valorP0"
                           mode="currency"
                           currency="BRL"
                           locale="pt-BR"
                           formControlName="valorP0"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="valorAtual">Valor Atual</label>
            <p-inputNumber id="valorAtual"
                           mode="currency"
                           currency="BRL"
                           locale="pt-BR"
                           formControlName="valorAtual"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="numeroTap">Número TAP</label>
            <input id="numeroTap" pInputText formControlName="numeroTap"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="tipoTap">Tipo TAP</label>
            <input id="tipoTap" pInputText formControlName="tipoTap"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="dataTap">Data TAP</label>
            <p-date-picker id="dataTap" dateFormat="dd/mm/yy" formControlName="dataTap"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="valorTap">Valor TAP</label>
            <p-inputNumber id="valorTap"
                           mode="currency"
                           currency="BRL"
                           locale="pt-BR"
                           formControlName="valorTap"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="situacaoTap">Situação TAP</label>
            <input id="situacaoTap" pInputText formControlName="situacaoTap"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="andamento">Andamento</label>
            <p-date-picker id="andamento" dateFormat="dd/mm/yy" formControlName="andamento"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="infracoes">Infrações</label>
            <p-inputNumber id="infracoes"
                           formControlName="infracoes"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="grupo">Grupo</label>
            <input id="grupo" pInputText formControlName="grupo"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="nivel">Nível</label>
            <input id="nivel" pInputText formControlName="nivel"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="avanco">Avanço</label>
            <p-inputNumber id="avanco"
                           formControlName="avanco"
                           prefix="% "
                           mode="decimal"
                           minFractionDigits="2"
                           maxFractionDigits="2"
                           locale="pt-BR"
            >
            </p-inputNumber>
          </div>

          <div class="flex flex-col gap-2">
            <label for="judicial">Judicial</label>
            <input id="judicial" pInputText formControlName="judicial"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="localizacao">Localização</label>
            <input id="localizacao" pInputText formControlName="localizacao"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="rodovia">Rodovia</label>
            <input id="rodovia" pInputText formControlName="rodovia"/>
          </div>

          <div class="flex flex-col gap-2">
            <label for="curso">Curso</label>
            <input id="curso" pInputText formControlName="curso"/>
          </div>
          <div class="flex flex-col gap-2 col-span-1 sm:col-span-2  md:col-span-3 lg:col-span-4 xl:col-span-5">
            <label for="observacao">Observações</label>
            <input id="observacao" pInputText formControlName="observacao"/>
          </div>
        </form>

        <div class="mt-4 pt-3 border-t-2 border-[#E41B2E]">
          <button (click)="onClickHistorico(viewingItemId!)" type="button"
                  class="flex items-center gap-1 text-xs text-gray-500 hover:text-red-500 dark:text-gray-400 dark:hover:text-red-400 transition-colors">
            <app-icon-bold-clock [size]="'14px'" [color]="expandedHistoricoId === viewingItemId ? '#E41B2E' : 'currentColor'"></app-icon-bold-clock>
            Histórico
          </button>
        </div>

        @if (expandedHistoricoId === viewingItemId) {
          <div class="mt-3">
            @if (historicoLoading) {
              <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                <i class="pi pi-spin pi-spinner"></i> Carregando histórico...
              </div>
            } @else if (historicoEntries.length === 0) {
              <p class="text-xs text-gray-500 dark:text-gray-400">Nenhum evento registrado para esta notificação.</p>
            } @else {
              <ul class="flex flex-col gap-1.5">
                @for (evento of historicoEntries; track $index) {
                  <li class="flex items-start gap-2 text-xs rounded px-1.5 py-1"
                      [ngClass]="isStatusOuFaseEvento(evento)
                        ? 'bg-red-50 dark:bg-red-950/30 text-red-700 dark:text-red-300 font-medium'
                        : 'text-gray-700 dark:text-gray-300'">
                    <span class="w-1.5 h-1.5 mt-1 rounded-full flex-shrink-0"
                          [ngClass]="isStatusOuFaseEvento(evento) ? 'bg-red-600' : 'bg-red-500'"></span>
                    <span>
                      <strong>{{ evento.dataEvento | date:'dd/MM/yyyy HH:mm' }}</strong>
                      {{ formatHistoricoEvento(evento) }}
                    </span>
                  </li>
                }
              </ul>
            }
          </div>
        }
      }
    </p-fluid>
  </ng-content>

  <ng-template #footer>
    <div class="flex justify-end items-center w-full">
      <p-button (click)="showViewDialog = false" label="Fechar" styleClass="btn-transparent">
        <app-icon-close-square color="#E41B2E"/>
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<app-confirm-dialog (cancel)="onCancelDelete()"
                    (confirm)="deleteOne()"
                    [(visible)]="showConfirmDeleteDialog"
                    [closable]="false"
                    cancelLabel="Não, manter"
                    confirmLabel="Sim, excluir"
                    headerTitle="Excluir Notificação"
                    id="confirmDeleteDialog"
                    message="Esta ação vai apagar esta notificação de forma irreversível. Deseja continuar?">
</app-confirm-dialog>

<app-confirm-dialog (cancel)="cancelarSalvarEdicoes()"
                    (confirm)="confirmarSalvarEdicoes()"
                    [(visible)]="showSaveEditsDialog"
                    [closable]="false"
                    cancelLabel="Cancelar"
                    confirmLabel="Sim, salvar"
                    headerTitle="Salvar Alterações"
                    id="confirmSaveEditsDialog"
                    [message]="'Confirma salvar ' + pendingEditCount + ' alteração(ões)? Isso vai registrar no histórico das notificações.'">
</app-confirm-dialog>

<app-confirm-dialog (cancel)="cancelarDescartarEdicoes()"
                    (confirm)="confirmarDescartarEdicoes()"
                    [(visible)]="showDiscardEditsDialog"
                    [closable]="false"
                    cancelLabel="Cancelar"
                    confirmLabel="Sim, descartar"
                    headerTitle="Descartar Alterações"
                    id="confirmDiscardEditsDialog"
                    [message]="'Isso vai descartar ' + pendingEditCount + ' alteração(ões) ainda não salva(s). Deseja continuar?'">
</app-confirm-dialog>

<app-importar-arquivo (importCompleted)="get()" [(visible)]="showImportDialog"/>
